import React from 'react';
import type { ElementType, ReactNode } from 'react';
import type { ConfigType } from '@plone/registry';

interface SlateElement {
  styleName?: string;
}

interface ElementRendererProps {
  attributes: React.HTMLAttributes<HTMLElement>;
  children: ReactNode;
  element?: SlateElement;
}

const renderWithStyle =
  (Tag: ElementType) =>
  ({ attributes, children, element }: ElementRendererProps) => (
    <Tag {...attributes} className={element?.styleName ?? ''}>
      {children}
    </Tag>
  );

export default function installElementRenderer(config: ConfigType): ConfigType {
  const slate: any = config.settings.slate;

  // some element types need to rendered manually in order to apply css class behavior
  slate.elements = {
    ...(slate.elements ?? {}),
    h1: renderWithStyle('h1'),
    h2: renderWithStyle('h2'),
    h3: renderWithStyle('h3'),
    h4: renderWithStyle('h4'),
    h5: renderWithStyle('h5'),
    h6: renderWithStyle('h6'),
  };

  return config;
}